import { Avatar, AvatarGroup, Grid } from '@mui/material';
import { Maybe, ProcureUser } from 'vendor-marketplace-shared-library';

type UserAvatarGroupProps = {
  users: Maybe<ProcureUser>[];
};
export function UserAvatarGroup(props: UserAvatarGroupProps) {
  return (
    <Grid container>
      <Grid item>
        {props.users.length > 1 ? (
          <AvatarGroup total={props.users.length}>
            {props.users.map(user => (
              <Avatar key={user?.id} src={user?.profilePictureAttachment?.url || ''} />
            ))}
          </AvatarGroup>
        ) : (
          <Avatar src={props.users[0]?.profilePictureAttachment?.url || ''} />
        )}
      </Grid>
    </Grid>
  );
}
